import { useLayoutEffect } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "../../components/container/MainContainer";
import PageTitle from "../../components/titles/PageTitle";
import { getCommunity } from "../../features/communitiesSlice";
import Loading from "../../components/loading/Loading";
import TextContainer from "../../components/text/TextContainer";
import Modal from "../../components/modal/Modal";
import AddCommunity from "./AddCommunity";
import { openModal } from "../../features/modalSLice";
import { useAuthorization } from "../../hooks/useAuthorization";
import DeleteCommunity from "./DeleteCommunity";
import { ChevronLeft, Save, Trash2 } from "lucide-react";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const SingleCommunity = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const modalContent = useSelector((state) => state.modal.content);
  const community = useSelector((state) => state.communities.selected);
  const loading = useSelector((state) => state.communities.load.getCommunity);

  const openEditCommunityModal = (edit, id) => {
    dispatch(openModal(<AddCommunity edit={edit} id={id} />));
  };

  const openDeleteCommunityModal = (id) => {
    dispatch(openModal(<DeleteCommunity id={id} />));
  };

  useLayoutEffect(() => {
    dispatch(getCommunity(id));
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.loading) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <PageTitle title={"Community - " + community.name} />
      <div className="bg-content  border border-bkg2 rounded-md p-7 mb-5 !text-text-1/55">
        <TextContainer label="Name" content={community.name} />
        <TextContainer label="Email" content={community.email} />
        <TextContainer label="Address 1" content={community.address1} />
        <TextContainer label="Address 2" content={community.address2} />
        <TextContainer label="City" content={community.city} />
        <TextContainer label="Station" content={community.organization} />
        <TextContainer label="Country" content={community.country} />
      </div>
      <div className="p-4 border border-bkg2 rounded-md flex justify-between items-center">
        <Link to="/communities" className="cancel-rss-btn">
          <ChevronLeft size={18} /> Back
        </Link>
        <div className="flex gap-3">
          <button
            onClick={(e) => openEditCommunityModal(true, id)}
            disabled={!isAuthorized("communities", "update")}
            className="add-rss-btn"
          >
            <Save size={18} />
            Edit
          </button>
          <button
            onClick={(e) => openDeleteCommunityModal(id)}
            disabled={!isAuthorized("communities", "delete")}
            className="delete-rss-btn"
          >
            <Trash2 size={18} />
            Delete
          </button>
        </div>
      </div>
    </MainContainer>
  );
};

export default SingleCommunity;
